import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import MuiSwitch from '@material-ui/core/Switch';

import { withStyles } from '@material-ui/core/styles';

const switchStyles = theme => ({
  switchBase: {
    '&$disabled + $track': {
      opacity: 0.38,
    },
    '&$disabled': {
      color: theme.palette.facet.lightGray,
    },
  },
  disabled: {},
  track: {},
});

function Switch({
  className,
  classes,
  helperText,
  value,
  style,
  ...rest
}) {
  return (
    <div className={classNames(classes.root, className)}>
      <MuiSwitch
        variant="outlined"
        checked={value}
        {...rest}
      />
    </div>
  );
}

Switch.defaultProps = {
  className: '',
};

Switch.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default withStyles(switchStyles, { name: 'Switch' })(Switch);
